import { PuffLoader } from "react-spinners";

function Loader({size}) {
  return (
    <div className="w-full px-2 flex-colo">
      <PuffLoader color="#fff" size={size}/>
    </div>
  );
}

export default Loader;
